module.exports = __webpack_public_path__ + "img/logo-bramfeld-small@2x.cfe05db8.png";